// Will be relocated/interfaced once the service for retrieving these is made
export class CarouselItem {
    imageUrl: string;
    carouselCaption: string;
    carouselBodyHeadline: string;
    carouselBody: string;
}
